import moment from 'moment'
import React from 'react'

// components
import Link from '@mui/material/Link'
import CamperStatusAvatar from 'components/shared/CamperStatusAvatar'

// local components
import LogInCamperLinkContainer from './LogInCamperLink'

const StatusText = props => {
  const { reupRequired, camper, account } = props
  const { camperSessions } = camper
  const { accountFeatures = [] } = account

  const onlineSession =
    camperSessions &&
    camperSessions.find(
      camperSession =>
        camperSession.session.sessionType === 'online' &&
        camperSession.registered
    )

  if (onlineSession) {
    const isOpen =
      moment() >= moment(onlineSession.session.startsAt) ||
      accountFeatures.find(f => f.name == 'VirtualBeta')
    if (isOpen) {
      return <LogInCamperLinkContainer camper={camper} />
    }
  }

  if (reupRequired && camper.confirmed) {
    return `Confirmed for ${camper.confirmedForYear}`
  }

  if (camperSessions && camperSessions.some(cs => cs.registered)) {
    return 'Registered'
  }

  return 'Not Registered'
}

export default function CamperStatus(props) {
  const { camper } = props

  return (
    <CamperStatusAvatar camper={camper} status={<StatusText {...props} />} />
  )
}
